var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.185,
    height: 10,
    viewBox: "0 0 17.185 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8500",
    "data-name": "Path 8500",
    d: "M16.806,5.311S13.268,9.622,8.9,9.622,1,5.311,1,5.311,4.538,1,8.9,1,16.806,5.311,16.806,5.311Z",
    transform: "translate(-0.311 -0.311)",
    fill: "none",
    stroke: "#ebebeb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8501",
    "data-name": "Path 8501",
    d: "M13.484,1.657a2.874,2.874,0,1,1-4.627,0",
    transform: "translate(-2.579 -0.515)",
    fill: "none",
    stroke: "#ebebeb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.eace9f2444adc6f09efecc8aec90bc6c.svg";
export { ForwardRef as ReactComponent };